export default "<spec-app-type3-number-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type3-number-table>\n";